import React from "react";
import "./OverView.css";
import { LuBarChart3 } from "react-icons/lu";
import { PiWavesLight, PiShareNetwork, PiStack } from "react-icons/pi";

const benefits = [
  {
    Icon: LuBarChart3,
    title: "Asset Tracking and Tagging",
    text: "Barcode, QR code, and RFID support for location, condition, and maintenance tracking.",
  },
  {
    Icon: PiWavesLight,
    title: "Data Analytics & KPIs",
    text: "Measure Overall Equipment Effectiveness (OEE) and utilization to eliminate inefficiencies.",
  },
  {
    Icon: PiShareNetwork,
    title: "Asset Utilization",
    text: "Maximize uptime and extend usable life using real-time IoT monitoring and trained maintenance workflows.",
  },
  {
    Icon: PiStack,
    title: "Operational Consolidation",
    text: "Replace scattered Excel spreadsheets with a single, secure cloud environment accessible anywhere.",
  },
];

const Benefits = () => {
  return (
    <section className="WhyAM bg-gradient-to-br from-[#002C78] via-[#001f54] to-[#001538] py-12 sm:py-16 text-white font-['Poppins',sans-serif] relative overflow-hidden" id="Benefits">
      {/* Background glow circle */}
      <div className="absolute top-0 right-0 w-[500px] h-[300px] bg-blue-500/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="mx-auto w-full max-w-[110rem] px-5 sm:px-14 relative z-10">
        <div className="mb-10 sm:mb-12 text-center sm:text-left">
          {/* <div className="inline-block rounded-full bg-white/10 px-4 py-1 text-xs font-semibold uppercase tracking-wider text-[#ff9e80] border border-white/10 mb-4">
            Benefits & Outcomes
          </div> */}
          <h2 className="mb-3 text-3xl sm:text-4xl lg:text-[2.6rem] font-bold leading-tight text-white">
            Benefits
          </h2>
          <div className="w-20 h-1 bg-[#F23100] mb-4"></div>
          <h3 className="text-xl font-medium text-blue-200">
            Core benefits of moving to iAssetMax™
          </h3>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {benefits.map(({ Icon, title, text }) => (
            <article
              key={title}
              className="group flex flex-col gap-5 rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-sm transition-all duration-300 hover:bg-white/10 hover:shadow-2xl hover:-translate-y-2 hover:border-[#F23100]/50"
            >
              <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-gradient-to-br from-[#F23100] to-[#ff7a50] text-white shadow-lg transition-transform duration-300 group-hover:scale-110">
                <Icon className="text-[2rem]" aria-hidden="true" />
              </span>
              <h4 className="text-xl font-bold leading-snug text-white">
                {title}
              </h4>
              <p className="text-[0.98rem] leading-[1.8] text-blue-100/90">{text}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 sm:mt-12 rounded-2xl border border-white/10 bg-white/5 p-8 sm:p-10 backdrop-blur-sm">
          <p className="border-l-4 border-[#F23100] pl-6 text-[1.1rem] leading-[1.85] text-white/95">
            Software is only part of the answer. True operational success requires
            leadership, aligned priorities, and seamless collaboration.
            iAssetMax™ provides the accurate asset intelligence your teams need
            to drive continuous improvement.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
